import dayjs from "dayjs";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { forwardRef, useEffect, useState } from "react";

import { Holder } from "./Holder";
import DatePicker from "@/components/date-picker-v2";

interface Props {
  onChange: (val: string) => void;
  value?: string;
  defaultValue?: string;
  name?: string;
}

const RFDatePicker = forwardRef<HTMLElement, Props>((props, ref) => {
  const { t } = useTranslation("survey");
  const router = useRouter();
  const formate = router.locale === "zh-Hans" ? "YYYY-MM-DD" : "MM/DD/YYYY";
  const [visible, setVisible] = useState(false);
  const [date, setDate] = useState<Date>();

  useEffect(() => {
    if (props.defaultValue) {
      setDate(dayjs(props.defaultValue).toDate());
    }
  }, [props.defaultValue]);

  const renderHolderValue = (_date?: Date) => {
    const _dateStr = dayjs(_date).format(formate);
    if (router.locale === "zh-Hans") {
      return _dateStr.replace("-", "年").replace("-", "月") + "日";
    }
    return _dateStr;
  };

  return (
    <div>
      <Holder
        placeholder={t("mm-dd-yyy")}
        text={renderHolderValue(date)}
        onClick={() => setVisible(true)}
      />

      <DatePicker
        title=""
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        value={dayjs(date).toDate()}
        max={dayjs().toDate()}
        min={dayjs("1900-01-01").toDate()}
        onConfirm={(val) => {
          setDate(dayjs(val).toDate());
          props.onChange(dayjs(val).format("YYYY-MM-DD"));
        }}
      />
    </div>
  );
});

RFDatePicker.displayName = "RFDatePicker";
export default RFDatePicker;
